import { useEffect, useState, Fragment, useRef } from 'react';
import CustomInput from './CustomInput';
import Pencil from '../../../../assets/images/pencil.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { classSettings } from '../../../../Store/api/professor/settings';
import ArrowRight from '../../../../assets/images/Arrow-right-dark.svg';
import { useDispatch } from 'react-redux';

const days = ['S', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];

const ClassInfoSettings = ({ settings = { schedule: '', startDate: '1/1/2024', endDate: '1/1/2024' }, classId }) => {
  const openRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isStartOpen, setIsStartOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [infoSettings, setInfoSettings] = useState({
    schedule: '',
    startDate: new Date(),
    endDate: new Date(),
  });
  useEffect(() => {
    setInfoSettings({
      ...settings,
      schedule: settings.schedule ? settings.schedule.replace(/\s/g, '') : '',
    });
  }, [settings]);

  const changeHandler = (e) => {
    setInfoSettings((old) => ({ ...old, [e.target.name]: e.target.value }));
  };
  
  const setSchedule = (day) => {
    setInfoSettings((old) => {
      if (old.schedule.split(',').includes(day)) {
        return {
          ...old,
          schedule: old.schedule
            .split(',')
            .filter((e) => e !== day)
            .join(','),
        };
      } else {
        return { ...old, schedule: old.schedule + ',' + day };
      }
    });
  };

  return (
    <div className='box_border_settings date_Schedule'>
      <div className=''>
        <div className='settings_header'>
          <h2>class information</h2>
          <div className='settings_header'>
            <div className='mb-0 editt cursor d-flex align-items-center'>
              <p className={`text-uppercase cursor mb-0 ${isEditing ? 'text-decoration-none' : ''}`} onClick={() => setIsEditing(true)}>
                {isEditing ? 'editing' : 'edit'}
              </p>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div style={{ minHeight: '150px' }}>Loading...</div>
        ) : (
          <Fragment>
            <CustomInput isEditing={isEditing} title={'Name'} name={'courseName'} value={infoSettings.courseName} onChange={changeHandler} />
            <CustomInput isEditing={isEditing} title={'courseNumber'} value={infoSettings.courseNumber} onChange={changeHandler} />
            <CustomInput isEditing={isEditing} title={'Description'} value={settings?.book?.description} name={'description'} onChange={changeHandler} />
            <CustomInput isTitle name='name' isEditing={isEditing} title='Textbook name' value={settings?.book?.title} onChange={changeHandler} />
            <div className='setting_rows'>
              <p className='key'>Start/end date</p>
              <p className='value'>
                {isEditing ? (
                  <div className='main_part d-flex gap-0'>
                    <div>
                      <DatePicker
                        ref={openRef}
                        className='spacial_date_picker'
                        placeholderText='Start Date'
                        open={isStartOpen}
                        onCalendarOpen={() => {
                          setIsEndOpen(false);
                          setIsStartOpen(true);
                        }}
                        onCalendarClose={() => {
                          setIsStartOpen(false);
                        }}
                        closeOnScroll
                        onChange={(date) => {
                          setInfoSettings((old) => {
                            return { ...old, startDate: date };
                          });
                          setIsStartOpen(false);
                        }}
                        name='startDate'
                        selectsStart
                        readOnly={!isEditing}
                        selected={new Date(infoSettings.startDate)}
                        startDate={new Date(infoSettings.startDate)}
                        endDate={new Date(infoSettings.startDate)}
                        autoComplete='off'
                        dateFormat='MMMM dd yyyy'
                      />
                    </div>
                    {/* <div>-</div> */}
                    <div>
                      <DatePicker
                        className='spacial_date_picker w-100'
                        closeOnScroll
                        open={isEndOpen}
                        onCalendarOpen={() => {
                          setIsStartOpen(false);
                          setIsEndOpen(true);
                        }}
                        onCalendarClose={() => {
                          setIsEndOpen(false);
                        }}
                        readOnly={!isEditing}
                        placeholderText='End Date'
                        onChange={(date) => {
                          setInfoSettings((old) => {
                            return { ...old, endDate: date };
                          });
                          setIsEndOpen(false);
                        }}
                        name='endDate'
                        selectsEnd
                        selected={new Date(infoSettings.endDate)}
                        startDate={new Date(infoSettings.startDate)}
                        endDate={new Date(infoSettings.endDate)}
                        dateFormat='MMMM dd yyyy'
                        autoComplete='off'
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    className='main_part'
                    style={{
                      color: '#2e2e2d',
                      fontSize: '14px',
                      fontWeight: 500,
                    }}
                  >
                    {new Date(infoSettings.startDate)
                      .toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })
                      .replace(',', 'th')}{' '}
                    -{' '}
                    {new Date(infoSettings.endDate)
                      .toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })
                      .replace(',', 'th')}
                  </div>
                )}
                {isEditing && (
                  <p className='edit_buttton'>
                    <img
                      src={Pencil}
                      alt=''
                      onClick={() => {
                        setIsStartOpen((old) => !old);
                      }}
                      className='cursor'
                    />
                  </p>
                )}
              </p>
            </div>
            <div className='setting_rows align-items-start'>
              <p className='key'>Schedule</p>
              <p className='Create-custom-schedule'>
                <ul className='main_part d-flex align-items-center gap-3 flex-wrap' style={{ width: '60% !important' }}>
                  {days.map((day, i) => (
                    <li
                      key={i}
                      onClick={() => {
                        setSchedule(day);
                      }}
                      className={`option_1`}
                    >
                      <input type='checkbox' id='Mo' className='custom-checkbox' />
                      <label style={{ marginLeft: '0' }} htmlFor={day} className={!infoSettings.schedule.replace(/\s/g, '').split(',').includes(day) ? '' : 'tu_th'}>
                        <span className='title_1'></span>
                        {day}
                      </label>
                    </li>
                  ))}
                  {/* Add more days here */}
                </ul>
                <p className='edit_buttton'>{isEditing && <img src={Pencil} alt='edit' />}</p>
              </p>
            </div>
          </Fragment>
        )}
        {isEditing && (
          <div className='setting_rows' style={{ marginBottom: '0px', marginTop: '16px' }}>
            <p className='key'></p>
            <p className='value'>
              <p className='main_part'></p>
              <p
                className='edit_buttton cursor'
                onClick={() => {
                  setIsLoading(true);
                  dispatch(
                    classSettings({
                      id: classId,
                      body: {
                        courseName: infoSettings.courseName,
                        courseNumber: infoSettings.courseNumber,
                        startDate: infoSettings.startDate,
                        endDate: infoSettings.endDate,
                        schedule: infoSettings.schedule,
                        description: infoSettings.description,
                      },
                      onSuccess: (res) => {
                        setIsLoading(false);
                        setIsEditing(false);
                      },
                      onError: (error) => {
                        setIsLoading(false);
                        if (error.response && error.response.data.message) {
                          window.alert(error.response.data.message);
                        } else {
                          window.alert('Unknown error!!!');
                        }
                      },
                    })
                  );
                }}
              >
                Save <img src={ArrowRight} alt='save' />
              </p>
            </p>
          </div>
        )}
      </div>
      {/* Add more content here */}
    </div>
  );
};

export default ClassInfoSettings;
